/* eslint-disable import/default */

import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import routes from './routes';
import configureStore from './store/configureStore';
import { syncHistoryWithStore } from 'react-router-redux';
import './configurations';
import Tenant from './util/tenant';

import './styles/styles.css';
import 'react-rangeslider/lib/index.css';
import 'react-daterange-picker/dist/css/react-calendar.css';


require('./favicon.ico'); // Tell webpack to load favicon.ico

const store = configureStore();

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);
let themeName = Tenant.getTheme();

require('./styles/' + themeName);

render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>, document.getElementById('app')
);


// WEBPACK FOOTER //
// ./app/index.js